import { colors } from './colors';

export type ColorType = 'neutral' | 'info' | 'warning' | 'error' | 'success';

// [backgroundColor, contentColor, borderColor]
export const getColorsByType = (type: ColorType = 'info') => {
  const colorsPerType: Record<ColorType, string[]> = {
    neutral: [colors.grayLighter, colors.palePurple, colors.palePurpleLight],
    info: [colors.lightBlue, colors.blue, colors.blue],
    warning: [colors.orangeLighter, colors.orange, colors.orange],
    success: [colors.greenLighter, colors.green, colors.green],
    error: [colors.rose, colors.red, colors.redLight],
  };
  return colorsPerType[type];
};

export const getColorStylesByType = (type: ColorType = 'info') => {
  const [backgroundColor, color, borderColor] = getColorsByType(type);
  return { backgroundColor, borderColor, color };
};
